import { useAlert } from "../../../../components/AlertContextComponent";
import { useApi } from "../../../../service/ApiContext";
import strings from "../../../../utils/Strings";
import { LocalStorage } from "../../../../utils/Utils";
import Loader from "../../../../utils/Utils";
import { videolandingPageRequest } from "../../../../features/recommendation/vedio-recommendation/data/request/VideoLandingPageRequest";
import { VideoReportClient } from "../client/VideoReportClient";
import {
  ProgramList,
  
  ProgramListResponse,
  
  SubjectList,
  SubjectResponse,
  TopicListResponse,
  TopicResponse,
  VideoListRequest,
  VideoListResponse,
  VideoResponse,
} from "../interface/AdvancedFilterReponse";

const VideoExportApiCallServices = () => {
  const api = useApi();
  const { showAlert } = useAlert();
  const setAuthToken = () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
  };

  const getProgramList = async ({
    onCallBack,
  }: {
    onCallBack: (data: ProgramList[]) => void;
  }) => {
    Loader.showLoading();

    setAuthToken();
    try {
      await api
        .get<ProgramListResponse>(VideoReportClient.getProgramList)
        .then((val) => {
          onCallBack(val.data.programs);
        })
        .catch((e) => {});
    } catch (error) {
      showAlert({
        identity: "default",
        show: true,
        title:strings.error_msg.something_wrg,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  const getSubjectList = async ({
    onCallBack,
    programId,
  }: {
    onCallBack: (data: SubjectList[]) => void;
    programId: string;
  }) => {
    Loader.showLoading();

    setAuthToken();
    try {
       const param: videolandingPageRequest = {
           program_category: "Industry",
            program_id: programId,
          };
      await api
        .get<SubjectResponse>(
          VideoReportClient.getSubjectsList,param
        )
        .then((val) => {
          onCallBack(val.data.list_courses);
        })
        .catch((e) => {});
    } catch (error) {
      showAlert({
        identity: "default",
        show: true,
        title: strings.error_msg.something_wrg,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  const getTopicsList = async ({
    onCallBack,
    courseList,
  }: {
    onCallBack: (data: TopicResponse[]) => void;
    courseList: SubjectList[];
  }) => {
    Loader.showLoading();

    setAuthToken();
    try {
      await api
        .post<TopicListResponse>(
          `${VideoReportClient.getTopicsList}`,
          courseList
        )
        .then((val) => {
          onCallBack(val.data.topics);
        })
        .catch((e) => {});
    } catch (error) {
      showAlert({
        identity: "default",
        show: true,
        title: strings.error_msg.something_wrg,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  const getVideosList = async ({
    onCallBack,
    topicList,
  }: {
    onCallBack: (data: VideoResponse[]) => void;
    topicList: VideoListRequest[];
  }) => {
    Loader.showLoading();

    setAuthToken();
    try {
      await api
        .post<VideoListResponse>(
          `${VideoReportClient.getVideosList}`,
          topicList
        )
        .then((val) => {
          onCallBack(val.data.videos);
        })
        .catch((e) => {});
    } catch (error) {
      showAlert({
        identity: "default",
        show: true,
        title: strings.error_msg.something_wrg,
        message: strings.error_msg.something_wrg,
        button1Text: "Ok",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  return {
    getProgramList,
    getSubjectList,
    getTopicsList,
    getVideosList,
  };
};
export default VideoExportApiCallServices;
